class SwiperContainer extends HTMLElement {
    constructor() {
        super();
        this.defaultSettings = {
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                1374: {
                    slidesPerView: 4,
                    spaceBetween: 28,
                },
                769: {
                    slidesPerView: 3
                },
                639: {
                    slidesPerView: 2
                }
              }
        };
    }

    connectedCallback() {
        const settings = this.getAttribute('data-settings');
        this.settingsJSON = settings ? JSON.parse(settings) : {};

        this.createSlider();
    }

    createSlider() {
        const swiperContainer = this.querySelector('.swiper-container');
        if (!swiperContainer) {
            console.error('Swiper container not found inside the custom element');
            return;
        }

       
        const settings = Object.assign({}, this.defaultSettings, this.settingsJSON);

     
        try {
            this.swiper = new Swiper(swiperContainer, settings);
            console.log("Swiper initialized with settings:", settings);
        } catch (error) {
            console.error('Error initializing Swiper:', error);
        }
    }
}


customElements.define('swiper-container', SwiperContainer);








